import { ArrowBack, LoginOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";
import { CustomText, PaperButton } from "components";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export function DispatchHeader({
  backButton = false,
  title = "",
  backButtonIcon = false,
}) {
  const user = useSelector((state) => state?.auth?.user ?? {});
  const history = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch({ type: "RESET_AUTH" });
    dispatch({ type: "RESET_APP" });
    history("/");
  };

  return (
    <div className="py-4">
      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
        // divider={<Divider orientation="vertical" flexItem />}
      >
        {backButton && (
          <div className="flex items-center">
            {user?.role === "2" && (
              <ArrowBack
                className="pr-2 cursor-pointer"
                fontSize="large"
                style={{ fontSize: 32, color: "#003657" }}
                onClick={() => history(-1)}
              />
            )}
            <CustomText color="secondary" variant="h4" bold>
              {title}
            </CustomText>
          </div>
        )}
        {backButtonIcon && (
          <PaperButton
            className="text-xl"
            onClick={() => history(-1)}
            iconPosition="start"
            icon={
              <ArrowBack
                className="pr-2 cursor-pointer"
                fontSize="large"
                style={{ fontSize: 32, color: "#003657" }}
                onClick={() => history(-1)}
              />
            }
          >
            Back
          </PaperButton>
        )}
        <PaperButton
          className="text-xl"
          icon={<LoginOutlined />}
          onClick={handleLogout}
        >
          Log Out
        </PaperButton>
      </Stack>
    </div>
  );
}
